export default __webpack_public_path__ + "static/media/orbs_cave_white.0c707baa.jpg";